import React from 'react';
import { Navigate } from 'react-router-dom';
import ValidToken from "../middleware/ValidToken";

const useAuth = () => {
    const user = localStorage.getItem('authorization');
    
    return !!user;
};

const Guest = (WrappedComponent) => {
    const isAuthenticated = useAuth();
    
    return (props) => {
        
        if (isAuthenticated) {
            return <Navigate to="/" />;
        }

        return <WrappedComponent {...props} />;
    };
};

export default Guest;
